import React from 'react';
import { rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import { ISaveForLater } from '../../interfaces';
import uniqueId from 'lodash-es/uniqueId'

const SaveForLaterButton = () => {

    const dispatch = useAppDispatch();

    const savedForLaterIcons = useAppSelector(store => store.root.savedForLaterIcons);
    const randomIcon = useAppSelector(store => store.root.randomIcon);

    // form properties from redux store
    const strokeWidth = useAppSelector(store => store.form.strokeWidth);
    const strokeColor = useAppSelector(store => store.form.strokeColor);
    const hasStroke = useAppSelector(store => store.form.hasStroke);

    const fillColor = useAppSelector(store => store.form.fillColor);
    const hasFill = useAppSelector(store => store.form.hasFill);

    const backgroundColor = useAppSelector(store => store.form.backgroundColor);
    const backgroundType = useAppSelector(store => store.form.backgroundType);

    const rotation = useAppSelector(store => store.form.rotation);
    const scale = useAppSelector(store => store.form.scale);

    const sharpness = useAppSelector(store => store.form.sharpness);
    const smoothness = useAppSelector(store => store.form.smoothness);

    const saveForLaterHandler = () => {
        if(!randomIcon || !randomIcon.iconKey) return;

        const copy = [...savedForLaterIcons];

        const saveForLaterIcon: ISaveForLater = {
            id: uniqueId(),
            iconKey: randomIcon.iconKey,

            strokeWidth,
            strokeColor,
            hasStroke,

            fillColor,
            hasFill,

            backgroundColor,
            backgroundType,

            rotation,
            scale,

            sharpness,
            smoothness,
        };

        copy.unshift(saveForLaterIcon);
        dispatch(
            rootActions.saveForLaterIcons(copy)
        );

        // scroll to 'saved-for-later' section
        const $savedForLater = document.getElementById('saved-for-later');
        if(!$savedForLater) return;

        $savedForLater.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
        });
    };

    return (
        <button
            type="button"
            className="bg-gray-500 hover:bg-gray-600 text-gray-100 rounded-full px-12 py-3 text-lg whitespace-nowrap transition duration-150 ease-out hover:ease-in"
            onClick={ saveForLaterHandler }>Save for Later</button>
    )
};

export default SaveForLaterButton;